<div class="hamburger-button-classic">
    <button mat-icon-button>
        <mat-icon>
            menu
        </mat-icon>
    </button>
</div>